import debounce from 'lodash/debounce';

import { updateContent } from 'common/api/v1/core';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

const DEBOUNCE_DELAY_MS = 1500;

const debouncedSave = debounce((contentId, updatedData, dispatch) => {
    updateContent(contentId, {
        content: JSON.stringify(updatedData),
    }).catch((error) => {
        showReponseErrorsAsAlert(dispatch, error?.response);
    });
}, DEBOUNCE_DELAY_MS);

export default (contentId, updatedData) => (dispatch) => {
    if (!contentId || !updatedData) return;
    debouncedSave(contentId, updatedData, dispatch);
};
